import { useMemo } from 'react';
import { combineQueryResults } from '../../CommonUtils/combineQueryResults';
import { InsuranceDTO, useInsuranceQuery } from './api/useInsuranceQuery';
import {
  OptionsDTO,
  useAccountsOptionsQuery,
} from '../../Profile/Accounts/api/useAccountsOptionsQuery';

interface Params {
  clientId: string;
}

export interface InsuranceData extends InsuranceDTO {
  accountOptions: OptionsDTO;
}

export const useInsurance = ({ clientId }: Params) => {
  const insuranceQueryResult = useInsuranceQuery({ clientId });

  const optionsQueryResult = useAccountsOptionsQuery();

  const data: InsuranceData | null = useMemo(() => {
    if (!insuranceQueryResult.data || !optionsQueryResult.data) {
      return null;
    }

    return {
      ...insuranceQueryResult.data,
      accountOptions: optionsQueryResult.data.Options,
    };
  }, [insuranceQueryResult.data, optionsQueryResult.data]);

  return {
    ...combineQueryResults([insuranceQueryResult, optionsQueryResult]),
    data,
  };
};
